import {DataObject} from "@/services/data/dataObject";
import store from "@/store/store";
import FirebaseRead from "@/services/database/firebaseRead";
import TimeStamp from "@/services/timeStamp";
import SPIELER_MEMBERSHIP_HANDLER from "@/services/data/spieler/spielerMembershipHandler";
import SpielService from "@/services/data/spielService";
import AttestTargetDateService from "@/services/data/attestTargetDate";
import {firestoreFunctions} from "@/services/db";

export class BestaetigungenService extends DataObject {
    constructor(sportart) {
        super();
        this.landesVerbaende = []
        this.vereine = []
        this.selectedVerbandId = ''
        this.selectedVereinId = null
        this.geschlecht = 'f' // m oder f
        this.spieler = []
        this.seiten = 1
        this.spielerProSeite = 30
        this.setLandesVerbaende(sportart)
        this.saisonId = '1_1_'+ store.state.local.sportJahr.current.id
        this.loading = false
    }

    setLandesVerbaende(sportart){
        if ( !sportart ) return
        if ( sportart === 'Classic' ) {
            this.landesVerbaende = store.state.local.landesverbaende.map(lv=>({...lv, text: lv.id + ' - ' + lv.name}))
                .filter(lv => lv.id < '20')
        } else {
            this.landesVerbaende = store.state.local.landesverbaende.map(lv=>({...lv, text: lv.id + ' - ' + lv.name}))
                .filter(lv => lv.id >= '21')
        }

    }

    bindLVRealtimeData(){
        if ( this.selectedVerbandId && !store.state.realtime.landesverbaende[this.selectedVerbandId] ) {
            this.bindLV()
        }
    }
        bindLV(){
            store.dispatch('bindRealtimeDocument', {
                collection: 'landesverbaende',
                docId: this.selectedVerbandId,
                storeField: 'landesverbaende.' + this.selectedVerbandId,
            });
        }

    getVereineFromLV(){
        const lv = store.state.realtime.landesverbaende[this.selectedVerbandId]
        if ( !lv ) return []
        const vereine = Object.keys(lv.vereine).map(
            id => ({lvId: this.selectedVerbandId,
                    nr: this.selectedVerbandId+id,
                    value: this.selectedVerbandId+id,
                    text:  this.selectedVerbandId+id + ' - ' + lv.vereine[id].name,
                    ...lv.vereine[id]})
        )
        this.vereine = vereine
        return vereine
    }

    getVereinsNameById(){
        console.log ("this.vereine", this.vereine);
        console.log ("this.selectedVereinId", this.selectedVereinId);
        return this.vereine.find(verein => verein.nr === this.selectedVereinId)?.text
    }

    async loadSpieler(){
        if ( !this.selectedVereinId ) { this.spieler = []; return }
        this.loading = true
        firestoreFunctions.region = 'europe-west3'
        let addMessage = firestoreFunctions.httpsCallable('getBestaetigungen')
        addMessage({ vereinId: this.selectedVereinId,
                          todayDate: TimeStamp.getTodayString(),
                          sportJahr: store.state.local.sportJahr.current.value,})
            .then((result) => {
                // Read result of the Cloud Function.
                console.log ("result",result );
                this.spieler = result.data.filter(spieler => spieler.geschlecht === this.geschlecht).map(
                    spieler => ({lvId: this.selectedVerbandId,
                        ...spieler,
                        ade: spieler.ade ? TimeStamp.getStringDotDateFromString(spieler.ade, true) : '-',
                        dsv: spieler.dsv ? TimeStamp.getStringDotDateFromString(spieler.dsv, true) : '-',
                        attest: this.getAttest(spieler),
                        passNr: this.getPassNr(spieler),
                        ak: this.getAltersklasse(spieler),
                    })
                ).sort((a, b) => a.nachname > b.nachname ? 1 : -1)
                this.loading = false
                this.setSeiten()
            }).catch(()=>{
                this.loading = false
            });
    }

        getPassNr(spieler){
            const passNrs = SPIELER_MEMBERSHIP_HANDLER.getLastValidPassNr(spieler.memberships)
            const passNrLeihe = SPIELER_MEMBERSHIP_HANDLER.getMembershipsForToday(spieler.memberships).find(
                membership => membership.leihe === true
            )
            return passNrLeihe ? passNrLeihe.passNr : passNrs?.regular.length > 6 ? '-' : passNrs.regular
        }
        getAltersklasse(spieler){
            if ( !spieler.dates?.akHJ ) { return 'unbekannt' }
            return SpielService.getAltersklasse(spieler.dates.akHJ, spieler.dates.akJahr, this.saisonId, spieler.sportart)
        }
        getAttest(spieler){
            if ( !spieler.attest ) return '-'
            // Änderung 6.11.2023: Target Date wird am Server berechnet, weil Geburtsdatum benötigt wird!!!
            /*const targetDate = AttestTargetDateService.getTargetDates(
                spieler.attest, spieler.dates, {id: this.saisonId}
            )*/
            return TimeStamp.getStringDotDateFromString(spieler.attest, true);
        }

        setSeiten(){
                if ( this.spieler.length === 0 ) {this.seiten = 1; return }
                const docRatio = this.spieler.length/this.spielerProSeite
                return this.seiten = docRatio === Math.floor(docRatio) ? docRatio : Math.floor(docRatio) + 1
        }

    getSpielerProSeite(aktuelleSeite){
        const until = aktuelleSeite * this.spielerProSeite
        const from = (aktuelleSeite -1) * this.spielerProSeite
        return this.spieler.slice(from, until)
    }

}